import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme/palette';
import { SvgIconProps } from './SvgIcon.types';

type FilterIconProps = Omit<SvgIconProps, 'fontSize'> & {
  fontSize?: number | string;
};

export const FilterIcon = memo(({ className, fontSize = '1.25rem', color = colors.primary.main }: FilterIconProps) => {
  return (
    <SvgIcon className={className} style={{ fontSize }} width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d="M14 18.5C14 17.6716 13.3284 17 12.5 17H7.5C6.67157 17 6 17.6716 6 18.5C6 19.3284 6.67157 20 7.5 20H12.5C13.3284 20 14 19.3284 14 18.5Z"
        fill={color}
      />
      <path
        d="M17 11C17 9.89543 16.1046 9 15 9H5C3.89543 9 3 9.89543 3 11C3 12.1046 3.89543 13 5 13H15C16.1046 13 17 12.1046 17 11Z"
        fill={color}
      />
      <path
        d="M0 2.5C0 3.88071 1.11929 5 2.5 5H17.5C18.8807 5 20 3.88071 20 2.5C20 1.11929 18.8807 0 17.5 0H2.5C1.11929 0 0 1.11929 0 2.5Z"
        fill={color}
      />
    </SvgIcon>
  );
});
